var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#707271;}\r\n\t.st1{fill:#12173F;}\r\n\t.st2{fill:#5D76A9;}\r\n\t.st3{fill:#FFBB22;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.9,129.2c3.7-7,5.4-13.9,5.4-20.6c0-15.1-8.5-28.8-20.4-36.9c-16.6-11.2-41.4-12.9-58.9,8.2 c-25.6-3.5-47.1,3.5-55.3,7c-8.2-3.3-29.7-10.4-55.3-7c-17.6-21-42.5-19.4-59-8.2c-11.9,8.1-20.4,21.7-20.4,36.9 c0,6.7,1.7,13.6,5.4,20.6c-13.2,19.1-22.5,41.8-22.5,64.9c0,27.8,11.9,42.2,16.4,48.4c0,0,1.9-1.9,3.6-3.6 c12.6,32,34.2,49.3,60.2,65c0,0,0.6-3.1,1-6c28,24.3,41.3,18.3,70.5,51.2c29-32.9,42.8-27.1,70.5-51.2c0.5,2.9,1,6,1,6 c11.6-7,44.3-24.6,60.2-65c1.6,1.6,3.6,3.6,3.6,3.6c2.8-3.8,16.4-19,16.4-48.4C351.4,171.1,342.3,148.3,328.9,129.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.9,129.6c26.8-41-33.9-83.7-63.2-42.4c-29.6-5.2-54.7,5.5-58,7.1c-3.3-1.5-28.4-12.4-58-7.1 c-29.3-41.3-90,1.4-63.2,42.4C48,171.4,51,212.7,65.2,232.1l5.8-5.8c0,0,8.3,40.3,52.2,66.8l1.6-8.7c27,28.9,51.7,28.2,74.9,54.6 c23.2-26.4,47.9-25.7,74.9-54.6l1.6,8.7c43.9-26.5,52.2-66.8,52.2-66.8l5.8,5.8C348.4,212.6,351.4,171.4,320.9,129.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200,283c0,0-21,0.3-24.2,2.3c0,0-3.6,6.3,24.2,6.2c26.5-0.1,22.6-5,22.8-5.6C222.6,285.7,213.8,283,200,283"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.7,258.5c0,0,3.2-9.5,6.8-6.5c4.9,4.2,11.2,12.7,11.2,13.5v11.3l-7.7,0.4c-4.4,0.1-18.7,3.5-18.7,3.5 c-19.6-48.5-8.8-85.1-3.5-98.3c-19.4,4.2-22.6-19-22.6-19c2-0.4,5,0.5,8.4,2.1c5.1,2.5,11.3,6.7,16.2,10.5l0,0 c1.4,1.1,2.8,2.2,3.9,3.1c13.2,11.1,23.9,8.9,23.9,8.9v47.4C199.7,235.4,161.2,232.5,181.7,258.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.8,258.5c24.5-24.9-15.5-23.4-18-23C203.9,235.7,234.9,235.9,217.8,258.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.1,183.3c22.1,59.4-5.9,97.6-6.1,97.8c17.3-45.4,6.2-83.2-1.4-97.3c-3.9,0.4-8.6,0.2-8.6,0.2 s5.9-3.6,9.6-7c0.3-0.3,0.6-0.5,0.9-0.8c3.1-2.8,9.1-7.7,16.5-10.6l0,0c2.7-1,5.5-1.8,8.5-2.1C253.5,163.4,251.4,183.1,234.1,183.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269,106.4c0,0,9-22.5,36.6-17c0,0-25.3-16.7-42.9,13.4c0,0-25.2-11.8-62.9,4.5c0,0-35.4-12.5-62.3-5.4 c0,0-15.7-27.2-37.8-16S89,123,92.8,129.7c0,0-36.7,37.3-22.9,83.4l7.3-9.2c0,0,10.5,50.3,37.7,66.1l1.6-12.4 c0,0,28.4,34.2,61.7,48.8c3.1,1.5,20.9,10.3,21.3,14.6v-23.9c0,0-23.1,1.9-29.2-8.8c-4.2-7.2-30.8-54.7-17.6-104.4 c0,0-12.8-1.9-15.2-23.5c0,0-9.5-4.7-21.4-3.7c0,0,21.2-6.7,41,1c19.9,7.7,25.1,27.2,38.7,18.6l3.7-55.1l4.2,55.3 c13.4,8.7,18.8-11,38.7-18.6c19.9-7.7,41-1,41-1s-8.5-6-22.1-8.7c-11.3-2.3-28.1,5-28.1,5s2.3-15.6,9.9-24 C249.7,122,264.5,120.4,269,106.4z M97.6,125.5c-0.8-7.5,8.7-15,8.7-15c-3.9-4-10.8-0.6-10.8-0.6c6.2-12.1,20.1-6.2,20.1-6.2 c-5.2-6.5-16.4-6-16.4-6C113,84,129.7,105,129.7,105C114.8,108.3,97.6,125.5,97.6,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.9,176c-2.1-0.7-5.6,1.5-7.6,5.3c-6.6-1.9-8.9-9-8.6-15.8l0,0C160.8,168,166.9,172.2,171.9,176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.6,181.4c-2.1-4-5.8-6.3-7.9-5.2c3.1-2.8,9.1-7.7,16.5-10.6l0,0C245.4,172.3,243,179.4,236.6,181.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMem);
export default __webpack_public_path__ + "static/media/MEM.a92cc898e9f7d6d2418fb5e698cdfc63.svg";
export { ForwardRef as ReactComponent };